import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

export const SYSTEM_MESSAGE_TYPE: string = "SystemMessageChannel";

export interface ISystemMessageService {
  getSystemMessages(): Observable<CubiqTS.SystemMessage>;
}
